import { Link } from "react-router-dom";
import { Hammer, ChevronRight } from "lucide-react";

const Seg = ({ to, n, label, tone, testid }) => (
  <Link to={to} data-testid={testid} className="rounded-lg px-2 py-1 text-sm hover:bg-white/[0.06]">
    <span className={`font-display font-semibold tabular-nums ${n ? tone : "text-slate-500"}`}>{n || 0}</span> <span className="text-slate-400">{label}</span>
  </Link>
);

export const WorkshopStrip = ({ c }) => (
  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-2xl border border-white/[0.07] bg-[#0F1F3D]/80 px-4 py-3" data-testid="workshop-strip">
    <Link to="/atelier" className="mr-2 flex items-center gap-2 font-display font-semibold text-white" data-testid="workshop-strip-link"><Hammer className="h-4 w-4 text-cyan-300" />Atelier</Link>
    <Seg to="/atelier" n={c.workshop} label="en atelier" tone="text-cyan-300" testid="workshop-strip-total" />
    <Seg to="/atelier?cat=workshop_diag" n={c.workshop_diag} label="à diagnostiquer" tone="text-amber-300" testid="workshop-strip-diag" />
    <Seg to="/atelier?cat=workshop_wait" n={c.workshop_wait} label="en attente" tone="text-amber-300" testid="workshop-strip-wait" />
    <Seg to="/atelier?cat=workshop_repair" n={c.workshop_repair} label="en réparation" tone="text-cyan-300" testid="workshop-strip-repair" />
    <Seg to="/atelier?cat=workshop_ready" n={c.workshop_ready} label="prêts" tone="text-emerald-300" testid="workshop-strip-ready" />
    <ChevronRight className="ml-auto hidden h-4 w-4 text-slate-500 sm:block" />
  </div>
);
